import {DocumentNode, gql} from "@apollo/client";

export const CHECK_PAYMENT_PUBlIC_MUTATION: DocumentNode = gql(`
    mutation CheckPaymentPublic($internalId: String!) {
        checkPaymentPublic(internalId: $internalId) {
            message
        }
    }
`);
